import { AzureDevOpsWorkItemsProperty } from "src/components";
import {
  ActionItemDetailDto,
  useAddActionItemAzureDevOpsWorkItem,
  useRemoveAzureDevOpsWorkItemFromCollection,
} from "src/http";

interface Props {
  actionItem: ActionItemDetailDto;
}

const ActionItemAzureDevOpsWorkItemsProperty = (props: Props) => {
  const { mutate: addAzureDevOpsWorkItem, isLoading: isAdding } = useAddActionItemAzureDevOpsWorkItem();
  const { mutate: removeAzureDevOpsWorkItem, isLoading: isRemoving } = useRemoveAzureDevOpsWorkItemFromCollection();

  function handleWorkItemAdded(workItemId: number, includeChildren: boolean) {
    addAzureDevOpsWorkItem({
      actionItemGuid: props.actionItem.guid,
      azureDevOpsWorkItemCollectionGuid: props.actionItem.azureDevOpsWorkItemCollectionGuid,
      workItemId,
      includeChildren,
    });
  }

  function handleWorkItemRemoved(workItemId: number) {
    if (props.actionItem.azureDevOpsWorkItemCollectionGuid == null) {
      return;
    }

    removeAzureDevOpsWorkItem({
      azureDevOpsWorkItemCollectionGuid: props.actionItem.azureDevOpsWorkItemCollectionGuid,
      workItemId,
    });
  }

  return (
    <AzureDevOpsWorkItemsProperty
      azureDevOpsWorkItemCollectionGuid={props.actionItem.azureDevOpsWorkItemCollectionGuid}
      disabled={isAdding || isRemoving}
      userCanEdit={props.actionItem.userCanEdit}
      onWorkItemAdded={handleWorkItemAdded}
      onWorkItemRemoved={handleWorkItemRemoved}
    />
  );
};

export { ActionItemAzureDevOpsWorkItemsProperty };
